<div id="{{tab.Id}}" class="productTabContainer" [ngStyle]="{ 'display': isShowing }">
    <product-detail-tab [tabId]="tab.Id" [productId]="productId"></product-detail-tab>
</div>
